import { render, staticRenderFns } from "./PsForm.vue?vue&type=template&id=18680ada&scoped=true&"
import script from "./PsForm.vue?vue&type=script&lang=js&"
export * from "./PsForm.vue?vue&type=script&lang=js&"
import style0 from "./PsForm.vue?vue&type=style&index=0&id=18680ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18680ada",
  null
  
)

export default component.exports